(function (window, $) {
  initShare();

  function initShare() {
    // Social Share for Facebook Clicks on My Account
    $('a.share-facebook').on('click', function (e) {
      e.preventDefault();
      var $this = $(this);
      var quote = $this.data('quote');
      var shareUrl = $this.data('url');

      FB.ui({
        method: 'share',
        display: 'popup',
        href: shareUrl,
        quote: quote
      });
    });

    // Notification banner related events
    $('.campaign-share-links .campaign-share-icon').on('click', function (e) {
      var $clickedLink = $(this);

      if ($clickedLink.hasClass('campaign-share-icon-link')) {
        e.preventDefault();

        if (SC.utils.copyTextToClipboard($clickedLink.attr('href'))) {
          confirmation(null, 'Link copied to clipboard.');
          SC.analytics.mp.logEvent('Challenge_Spring19 - Copy Link', 'navigation', {'Location': 'Landing Page'});
        } else {
          confirmation(null, 'Failed to link to clipboard.');
        }
      }

      if ($clickedLink.hasClass('campaign-share-icon-twitter')) {
        e.preventDefault();
        // 500x285 is the size of the twitter popup we're going to use
        SC.utils.popupCenter($(this).attr('href'), 'Twitter', 550, 285);
      }
    });
  }
})(window, jQuery);
